
export default class FormItemTimeDisplay
{
	static defaultShowHour = true;
	static defaultShowMin = true;
	static defaultShowSeconds = true;
	
    static getDisplayText(value,showHour,showMinute,showSecond)
	{
		if(value=="" || value == " ")
		{
			return "";
		}
		else if(value == null)
		{
			return "00:00:00";
		}else if(value=="00:00:00"){
			return "";
		}
		else
		{
			var array = value.split(":");
			if(array.length!=3)
			{
				throw new Error("time value error:" + value);
			}
			if(!showHour)
			{
				array[0] = "";	
			}
			if(!showMinute)
			{
				array[1] = "";
			}
			if(!showSecond)
			{
				array[2] = "";
			}
			
			return array[0]+
					( (array[0] =="" || array[1] == "")?"":":")+
					array[1]+
					( array[2] == ""?"":":")+
					array[2];
		}
		
	}

	static getDisplayText2(value,displayFormat)
	{
		if(!value)return value;
		let date = new Date("2020-12-12 "+value);
		return FormItemTimeDisplay.dateFormat2(displayFormat,date);//date.format(displayFormat);
	}

	
	static dateFormat2(fmt,date)
	{
		var o = {
			"H+": date.getHours(), //小时 
			"N+": date.getMinutes(), //分 
			"S+": date.getSeconds()//秒
		};
		for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		return fmt;
	}

}



// WEBPACK FOOTER //
// ./src/formItem/display/FormItemTimeDisplay.js